import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { SelectFilter } from '@sabstravtech/obtservices/base';
import { WithSubscriptionComponent } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss'],
  standalone: false
})
export class SelectFilterComponent extends WithSubscriptionComponent implements OnInit {
  @Input() items: Record<number | string, SelectFilter> = {};
  @Input() alphabetical = false;
  @Input() inbound = false;
  @Input() showAll = true;
  @Output() change = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit(): void {}

  arrangeAlphabetically(filters): any[] {
    return filters.sort((a: any, b: any) => {
      const aDisplay = (a.value?.display ?? '').trim();
      const bDisplay = (b.value?.display ?? '').trim();
      return aDisplay.localeCompare(bDisplay);
    });
  }
}
